import React, { useState } from "react";
import { useLocation } from 'react-router-dom';
import { FiDownload } from "react-icons/fi";
import * as XLSX from "xlsx";
import logo from "../../assets/logo-1.png"


const AdminDashboard = () => {
    const location = useLocation();
    const data = location.state?.data || [];
    const [leads, setLeads] = useState(data);
    const [searchQuery, setSearchQuery] = useState("");

    const filteredLeads = leads.filter(
        (lead) =>
            lead.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            lead.phone?.includes(searchQuery)
    )

    const handleSearch = (event) => {
        setSearchQuery(event.target.value)
    }

    const downloadExcel = () => {
        const selectedData = filteredLeads.map(({ phone, name, message, location, ts }) => ({
            Phone: phone,
            Name: name,
            Message: message,
            Location: location,
            Date: ts,
        }));

        const ws = XLSX.utils.json_to_sheet(selectedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Leads");
        XLSX.writeFile(wb, "Leads_List.xlsx");
    }

    return (
        <div className="flex">
            <div className="p-6 bg-gray-100 min-h-screen flex-1">
                <div className="bg-white shadow-md rounded-lg p-6">
                    <div className="flex justify-between items-center mb-6">
                        {/* <h2 className="text-xl font-bold">Leads List</h2> */}
                        <img className="w-40" src={logo} alt="Company Logo" />
                        <div className="flex gap-4">
                            <input
                                type="text"
                                placeholder="Search by Name or Phone..."
                                value={searchQuery}
                                onChange={handleSearch}
                                className="border p-2 rounded-md focus:outline-none"
                            />
                            <button
                                onClick={downloadExcel}
                                className="bg-pink-600 text-white px-3 py-2 rounded-md hover:bg-pink-700 flex items-center gap-2"
                            ><FiDownload size={20} />
                            </button>
                        </div>
                    </div>

                    <table className="w-full table-auto border-collapse">
                        <thead>
                            <tr className="bg-pink-600 text-white">
                                <th className="p-2 text-center">Name</th>
                                <th className="p-2 text-center">Phone</th>
                                <th className="p-2 text-center">Time</th>
                                <th className="p-2 text-center">Pickup Location</th>
                                <th className="p-2 text-center">Drop Location</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[...filteredLeads].reverse().map((lead, index) => (
                                <tr
                                    key={index}
                                    className={`${index % 2 === 0 ? "bg-gray-50" : "bg-white"
                                        } hover:bg-gray-100 transition`}                                >
                                    <td className="p-2 text-center">{lead.name}</td>
                                    <td className="p-2 text-center">{lead.phone}</td>
                                    <td className="p-2 text-center">{lead.ts}</td>
                                    <td className="p-2 text-center">{lead.pickup}</td>
                                    <td className="p-2 text-center">{lead.drop}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {filteredLeads.length === 0 && (
                        <p className="text-center text-gray-500 py-4">No leads found.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;